package top.wcpe.allincore.ui.runtime.ir.prop

import top.wcpe.allincore.ui.runtime.element.ModelPreview
import top.wcpe.allincore.ui.runtime.ir.eval.ValueCoercion
import kotlin.jvm.JvmStatic

/** ModelPreview 独立属性贡献者。 */
internal object ModelPreviewPropContributor {

    @JvmStatic
    fun contribute(bindings: MutableMap<String, PropBinding>) {
        register(bindings, "source") { element, value -> element.source(value?.toString()) }
        register(bindings, "texture") { element, value -> element.texture(value?.toString()) }
        register(bindings, "scale") { element, value ->
            if (value != null) element.scale(ValueCoercion.toFloat(value))
        }
        register(bindings, "rotationX") { element, value ->
            if (value != null) element.rotationX(ValueCoercion.toFloat(value))
        }
        register(bindings, "rotationY") { element, value ->
            if (value != null) element.rotationY(ValueCoercion.toFloat(value))
        }
        register(bindings, "interactive") { element, value ->
            if (value != null) element.interactive(ValueCoercion.toBool(value))
        }
        register(bindings, "backgroundColor") { element, value ->
            element.backgroundColor(value?.let(ValueCoercion::toIntColor) ?: 0)
        }
    }

    private fun register(
        bindings: MutableMap<String, PropBinding>,
        key: String,
        apply: (ModelPreview, Any?) -> Unit,
    ) {
        val existing = bindings[key]
        val combined: PropApplier = { element, value ->
            if (element is ModelPreview) {
                apply(element, value)
            } else {
                existing?.applier?.apply(element, value)
            }
        }
        bindings[key] = PropBinding(combined, existing?.reader, existing?.affectsLayout ?: false)
    }
}
